
import { Box, Card, Typography } from '@mui/material';
import {
  MRT_Row,
  MRT_RowData,
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions
} from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import React from 'react';

type DetailPanelRenderer<T extends Record<string, any>> = (args: {
  row: MRT_Row<T>;
}) => React.ReactNode;

interface SampleTableProps<T extends MRT_RowData> extends MRT_TableOptions<T> {
  columns: MRT_ColumnDef<T>[];
  data: T[];
  enablePagination?: boolean;
  density?: 'comfortable' | 'compact' | 'spacious';
  rowNumber?: boolean;
  enableVirtualization?: boolean;
  enableTopToolbar?: boolean;
  isLoading?: boolean;
  rowColor?: (row: T) => React.CSSProperties;
  enableSticky?: boolean;
  maxHeight?: number
  renderDetailPanel?: DetailPanelRenderer<T>
  //enableDetailPanel?: boolean;
  //getRowCanExpand?: (row: any) => boolean;
}

const SampleTable = <T extends MRT_RowData>({
  columns,
  data,
  enablePagination = false,
  density = 'comfortable',
  rowNumber = false,
  enableVirtualization = false,
  enableTopToolbar = false,
  isLoading = false,
  rowColor,
  enableSticky = false,
  maxHeight,
  renderDetailPanel,
}: SampleTableProps<T>) => {
  const table = useMaterialReactTable({
    columns,
    data,
    localization: MRT_Localization_ES,
    enableRowNumbers: rowNumber,
    enableRowVirtualization: enableVirtualization,
    enableColumnFilters: false,
    enablePagination: enablePagination,
    enableSorting: false,
    enableFullScreenToggle: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableColumnActions: false,
    enableRowActions: false,
    enableTopToolbar,
    state: {
      //expanded: true,
      density: density,
      isLoading: isLoading,
    },
    muiTablePaperProps: {
      elevation: 0,
    },
    muiPaginationProps: {
      showRowsPerPage: false,
    },
    muiTableBodyCellProps: {
      align: 'center',
    },
    muiTableHeadCellProps: {
      align: 'center',
    },
    enableStickyHeader: enableSticky,
    muiTableContainerProps: {
      sx: { maxHeight: maxHeight || "auto" }
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: rowColor ? rowColor(row.original) : {}
    }),
    ///* detalle fila
    enableExpandAll: false,
    renderDetailPanel,
    displayColumnDefOptions: {
      'mrt-row-expand': {
        header: 'VER SERIES',
      },
    },
    ///*
    renderTopToolbarCustomActions: () => (
      <Typography
        variant="body2"
        style={{ fontWeight: 'bold', color: '#6b737f' }}
      >
        Total Items: {data?.length}
      </Typography>
    ),
  });

  return (
    <Card>
      <Box
        sx={{
          width: '100%',
        }}
      >
        <MaterialReactTable table={table} />
      </Box>
    </Card>
  );
};

export default SampleTable; 
